import { render, staticRenderFns } from "./MainProjectBidding.vue?vue&type=template&id=09a9fb0e&scoped=true"
import script from "./MainProjectBidding.vue?vue&type=script&lang=js"
export * from "./MainProjectBidding.vue?vue&type=script&lang=js"
import style0 from "./MainProjectBidding.vue?vue&type=style&index=0&id=09a9fb0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a9fb0e",
  null
  
)

export default component.exports